// extracted by mini-css-extract-plugin
export default {"demoBarLinkInlineWarning":"demoBarLinkInlineWarning__YrInz5qiwBDG"};